import React, { useRef } from "react";
import parse, { domToReact } from "html-react-parser";
import { Link } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
  CardActionArea,
  CardMedia,
  Grid,
  Container,
  FormControl,
  Snackbar,
  Alert,
  Button,
} from "@mui/material";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box } from "@mui/system";

function parseReactComponents(text) {
  const options = {
    replace: ({ name, attribs, children }) => {
      if (
        name === "a" &&
        attribs?.href?.includes(window.location.origin) &&
        !attribs?.href?.includes(".pdf")
      ) {
        console.log("a name", name);
        console.log(attribs);
        //console.log(window.location.origin)
        // let styleRef = useRef();
        // if(styleRef?.current?.style){
        // styleRef.current.style = attribs?.style || '';
        return (
          <Link
            // ref={styleRef}
            className={attribs?.class || ""}
            to={`${attribs.href.replace(window.location.origin, "")}`}
          >
            {domToReact(children)}
          </Link>
        );
        // }
      }

      if (
        name === "a" &&
        attribs?.href?.includes(window.location.origin) &&
        attribs?.href?.includes(".pdf")
      ) {
        // console.log(name)
        // console.log(attribs)
        //console.log(window.location.origin)
        // let styleRef = useRef();
        // if(styleRef?.current?.style){
        // styleRef.current.style = attribs?.style || '';
        return (
          <Link
            // ref={styleRef}
            className={attribs?.class || "external_link"}
            target="_blank"
            to={attribs.href}
          >
            {domToReact(children)}
          </Link>
        );
        // }
      }

      // cf7 form - needs work to convert post responce into axios and handle response.
      if (name === "form" && attribs?.class?.includes("wpcf7-form")) {
        console.log("cf7 form", children);
        let formId = children[1].children[0].attribs.value;

        console.log(formId);

        //const [snack, setOpenSnack] = useState({open: false, message: '', type: 'error'});

        // user state not working here...
        const snack = { open: false, message: "", type: "error" };
        const setOpenSnack = (event, reason) => {};

        const handleCloseSnack = (event, reason) => {
          if (reason === "clickaway") {
            return;
          }
          setOpenSnack({ open: false, message: "", type: "error" });
        };

        let handleSubmit = (event) => {
          event.preventDefault();

          // Disable button
          event.target.querySelector(".wpcf7-submit").disabled = true;
          //event.target.querySelector('.MuiCircularProgress-root').style.display = 'block';

          // var data = new FormData(document.querySelector('form#' + event.target.id))
          var data = new FormData(
            document.querySelector(`form[id="cf7form${event.target.id}"]`),
          );

          axios
            .post(
              `/wp-json/contact-form-7/v1/contact-forms/${formId}/feedback/`,
              data,
            )
            .then((res) => {
              // Enable button
              event.target.querySelector(".wpcf7-submit").disabled = false;
              //event.target.querySelector('.MuiCircularProgress-root').style.display = 'none';
              event.target.querySelector(
                `#formmessage${formId}`,
              ).style.opacity = "0";
              event.target.querySelector(
                `#formmessage${formId} .MuiAlert-standardSuccess`,
              ).style.display = "none";
              event.target.querySelector(
                `#formmessage${formId} .MuiAlert-standardError`,
              ).style.display = "none";

              // Remove errors
              var errors = event.target.querySelectorAll(".error");
              errors.forEach((errorItem) => {
                errorItem.classList.remove("error");
              });

              // Handle responce
              if (res.data.status == "mail_sent") {
                var redirect = false;

                // Boom all ok so clear the form and go yay!
                setOpenSnack({
                  open: true,
                  message: res.data.message,
                  type: "success",
                });
                event.target.reset();
                event.target.querySelector(
                  `#formmessage${formId}`,
                ).style.opacity = "1";
                event.target.querySelector(
                  `#formmessage${formId} .MuiAlert-standardSuccess`,
                ).style.display = "flex";
                event.target.querySelector(
                  `#formmessage${formId} .MuiAlert-standardSuccess .MuiAlert-message`,
                ).textContent = res.data.message;

                if (redirect !== false) window.location.href = redirect;
              } else {
                // Add error classes
                res.data?.invalid_fields?.forEach((field) => {
                  var fieldItem = event.target.querySelector("#" + field.idref);
                  fieldItem.classList.add("error");
                });

                // Snackbar
                setOpenSnack({
                  open: true,
                  message: res.data.message,
                  type: "error",
                });

                event.target.querySelector(
                  `#formmessage${formId}`,
                ).style.opacity = "1";
                event.target.querySelector(
                  `#formmessage${formId} .MuiAlert-standardError`,
                ).style.display = "flex";
                event.target.querySelector(
                  `#formmessage${formId} .MuiAlert-standardError .MuiAlert-message`,
                ).textContent = res.data.message;
              }
            });
        };

        return (
          <>
            <form id={`cf7form${formId}`} method="post" onSubmit={handleSubmit}>
              {domToReact(children)}

              {/* <CircularProgress  sx={{display: 'none'}} size={45} /> */}

              <Box
                id={`formmessage${formId}`}
                sx={{ float: "left", marginLeft: "10px", opacity: "0" }}
              >
                <Alert severity="success" sx={{ display: "none" }}>
                  Email Sent
                </Alert>
                <Alert severity="error" sx={{ display: "none" }}>
                  Error
                </Alert>
              </Box>
              <br clear="both" />
            </form>
            <Snackbar
              sx={{ height: "100%" }}
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              open={snack.open}
              autoHideDuration={6000}
              onClose={handleCloseSnack}
            >
              <Alert
                onClose={handleCloseSnack}
                severity={snack.type}
                sx={{ width: "100%" }}
              >
                {snack.message}
              </Alert>
            </Snackbar>
          </>
        );
      }

      // image with caption and class of boxed convert to Card
      if (name === "div" && attribs?.class?.includes("boxed")) {
        console.log(children);

        let link = children[1].children[0].attribs.href.replace(
          window.location.origin,
          "",
        ); // remove absolute path
        let image = children[1].children[0].children[0].attribs.src;
        let details = children[1].children[1].children;

        const navigate = useNavigate();

        return (
          <Card sx={{ height: "100%" }}>
            <CardActionArea
              sx={{ height: "100%" }}
              onClick={(e) => navigate(link)}
            >
              <CardMedia
                component="img"
                image={image}
                alt="title"
                sx={{ height: 240 }}
              />
              <CardContent>
                <Typography
                  variant="body2"
                  color="text.primary"
                  component="p"
                  sx={{
                    fontWeight: "600",
                    textAlign: "center",
                    fontSize: "1.2rem",
                  }}
                >
                  {domToReact(details)}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        );
      }
    },
  };

  return parse(text, options);
}

export default parseReactComponents;
